import React, { useEffect } from 'react'

const LegalPageLayout = ({ title, subtitle, lastUpdated, children }) => {
  useEffect(() => {
    document.title = `${title} — Clinique du Grand Paris`
    window.scrollTo(0, 0)
  }, [title])

  return (
    <article className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>{title}</h1>
          {subtitle && <p className="legal-subtitle">{subtitle}</p>}
          {lastUpdated && (
            <p className="legal-updated">Dernière mise à jour : {lastUpdated}</p>
          )}
        </header>

        <div className="legal-body">{children}</div>
      </div>

      <style jsx>{`
        .legal-page {
          background: #ffffff;
          padding: 120px 0 80px;
          min-height: 70vh;
          color: #1c1c1c;
        }

        .legal-container {
          max-width: 820px;
          margin: 0 auto;
          padding: 0 24px;
        }

        .legal-header {
          border-bottom: 1px solid #e8eaf6;
          padding-bottom: 32px;
          margin-bottom: 48px;
        }

        .legal-header h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(2rem, 4vw, 3rem);
          color: #2F2F84;
          margin: 0 0 16px;
          line-height: 1.15;
          font-weight: 700;
        }

        .legal-subtitle {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.25rem;
          color: #6466B0;
          font-style: italic;
          margin: 0 0 12px;
        }

        .legal-updated {
          color: #777;
          font-size: 0.9rem;
          margin: 0;
        }

        .legal-body {
          font-family: 'Inter', sans-serif;
          font-size: 1.05rem;
          line-height: 1.75;
          color: #2c2c2c;
        }

        .legal-body :global(h2) {
          font-family: 'Playfair Display', serif;
          font-size: 1.6rem;
          color: #2F2F84;
          margin: 48px 0 16px;
          padding-top: 8px;
          font-weight: 700;
        }

        .legal-body :global(h3) {
          font-family: 'Inter', sans-serif;
          font-size: 1.15rem;
          color: #2F2F84;
          margin: 32px 0 12px;
          font-weight: 600;
        }

        .legal-body :global(p) {
          margin: 0 0 16px;
        }

        .legal-body :global(ul),
        .legal-body :global(ol) {
          margin: 0 0 20px;
          padding-left: 24px;
        }

        .legal-body :global(li) {
          margin-bottom: 8px;
        }

        .legal-body :global(strong) {
          color: #2F2F84;
        }

        .legal-body :global(a) {
          color: #6466B0;
          text-decoration: underline;
          text-decoration-thickness: 1px;
          text-underline-offset: 3px;
        }

        .legal-body :global(a:hover) {
          color: #2F2F84;
        }

        .legal-body :global(.legal-card) {
          background: #f8f8fc;
          border: 1px solid #e8eaf6;
          border-radius: 8px;
          padding: 20px 24px;
          margin: 16px 0 32px;
        }

        .legal-body :global(.legal-card p:last-child) {
          margin-bottom: 0;
        }

        .legal-body :global(.legal-todo) {
          background: #fff8e1;
          border: 1px dashed #d4a843;
          border-radius: 6px;
          padding: 12px 16px;
          margin: 12px 0;
          font-size: 0.95rem;
          color: #6b5210;
        }

        .legal-body :global(table) {
          width: 100%;
          border-collapse: collapse;
          margin: 16px 0 32px;
          font-size: 0.98rem;
        }

        .legal-body :global(th),
        .legal-body :global(td) {
          text-align: left;
          padding: 12px 16px;
          border-bottom: 1px solid #e8eaf6;
          vertical-align: top;
        }

        .legal-body :global(th) {
          background: #f3f3f9;
          color: #2F2F84;
          font-weight: 600;
        }

        @media (max-width: 600px) {
          .legal-page {
            padding: 90px 0 60px;
          }
          .legal-body :global(table) {
            font-size: 0.92rem;
          }
          .legal-body :global(th),
          .legal-body :global(td) {
            padding: 10px 12px;
          }
        }
      `}</style>
    </article>
  )
}

export default LegalPageLayout
